<template>
  <div>
    <a-form :model="searchForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="IP地址">
            <a-input v-model="searchForm.ip_address" allowClear placeholder="请输入IP地址" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="IP归属地">
            <a-input v-model="searchForm.ip_address_belong_to" allowClear placeholder="请输入IP归属地" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="有效期">
            <v-range-picker v-model="searchForm.expiration_date" @change="onExpirationAtChange" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="创建人员">
            <a-input v-model="searchForm.created_name" allowClear placeholder="请输入创建人员" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="更新人员">
            <a-input v-model="searchForm.updated_name" allowClear placeholder="请输入更新人员" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="创建时间">
            <v-range-picker v-model="searchForm.created_at" @change="onCreateAtChange" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="更新时间">
            <v-range-picker v-model="searchForm.updated_at" @change="onUpdateAtChange" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="状态">
            <a-select
              v-model="searchForm.state"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择状态"
              style="width: 100%"
            >
              <a-select-option value="1">
                待生效
              </a-select-option>
              <a-select-option value="2">
                生效中
              </a-select-option>
              <a-select-option value="3">
                已失效
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="handleAdd">新增</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right: 10px" @click="search">查询</a-button>
        <a-button type="primary" ghost icon="delete" @click="handleClear">清空</a-button>
        <!-- <a-button icon="sync">刷新表格</a-button> -->
      </div>
    </div>

    <!-- 表格 -->
    <a-table
      size="middle"
      row-key="id"
      :columns="columns"
      :loading="loading"
      :data-source="data"
      :scroll="{ x: true }"
      :pagination="pagination"
      style="margin-top: 20px"
      @change="handleTableChange"
    >
      <template slot="user_id" slot-scope="text, record"> {{ record.user_name | fillBlank }} ({{ text }}) </template>
      <template slot="project" slot-scope="text, record">
        <span v-html="getOrgList(record)"></span>
      </template>
      <template slot="ip_address_belong_to" slot-scope="text, record">
        <span>{{ record.ip_address_belong_to?record.ip_address_belong_to:'-' }}</span>
      </template>
      <template slot="state" slot-scope="text, record">
        <span>{{ record.state===1?'待生效':record.state===2?'生效中':'已失效' }}</span>
      </template>
      <template slot="user_id" slot-scope="text, record">
        <p style="margin:0;">创建：{{ record.created_name }}({{ record.created_number }})</p>
        <p style="margin:0;">更新：{{ record.updated_name }}({{ record.updated_number }})</p>
      </template>
      <template slot="expiration_end_date" slot-scope="text, record">
        <p style="margin:0;">起：{{ time(record.expiration_start_date) }}</p>
        <p style="margin:0;">止：{{ time(record.expiration_end_date) }}</p>
      </template>
      <template slot="create_at" slot-scope="text, record">
        <p style="margin:0;">创建：{{ time(record.created_at) }}</p>
        <p style="margin:0;">更新：{{ time(record.updated_at) }}</p>
      </template>
      <template slot="operator" slot-scope="text, record">
        <div class="flex-sb">
          <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button size="small" type="link" danger @click="handleTableCommand('delete', record)">删除</a-button>
        </div>
      </template>
    </a-table>
    <!-- 添加 -->
    <addWhiteList v-model="visible" :isEdit="isEdit" :platformList="platformList" :params="waitItem" @handleOver="getList" />
  </div>
</template>
<script>
import { ref, reactive, onMounted, onUnmounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { strategyCommand } from './business/tableLogic'
import { searchForm, columns } from './business/whiteListSet'
import pagination from '@/composables/pagination'
import addWhiteList from './addWhiteList.vue'
import compuedFun from '../../computed/'
import api from '@/api/'
import moment from 'moment'
export default {
      components: { addWhiteList },
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      times: [],
      platformList: [],
      searchForm: { ...searchForm },
    })

    onMounted(async () => {
      await methods.getList()
      methods.getPlatform()
    })

    const methods = {
          time(time) {
        return (time = moment(time * 1000).format('YYYY-MM-DD HH:mm:ss'))
      },
        onUpdateAtChange(date, dateString) {
        if (dateString[0] === '') {
          _this.searchForm.updated_at = []
          return
        }
        _this.searchForm.updated_at = [
           Number(moment(dateString[0]).startOf('day').format('X')),
           Number(moment(dateString[1]).endOf('day').format('X')),
        ]
      },
        onCreateAtChange(date, dateString) {
        if (dateString[0] === '') {
          _this.searchForm.created_at = []
          return
        }
        _this.searchForm.created_at = [
           Number(moment(dateString[0]).startOf('day').format('X')),
           Number(moment(dateString[1]).endOf('day').format('X')),
        ]
      },
             onExpirationAtChange(date, dateString) {
        if (dateString[0] === '') {
          _this.searchForm.expiration_date = []
          return
        }
        _this.searchForm.expiration_date = [
           Number(moment(dateString[0]).startOf('day').format('X')),
           Number(moment(dateString[1]).endOf('day').format('X')),
        ]
      },
    // onCreateAtChange(dateString, type) {
    //     if (dateString[0] === '') {
    //       _this.searchForm[type] = []
    //       return
    //     }
    //     _this.searchForm[type] = [
    //       Number(moment(dateString[0]).startOf('day').format('X')),
    //       Number(moment(dateString[1]).endOf('day').format('X')),
    //     ]
    //   },
      search() {
        _this.pagination.current = 1
        this.getList()
      },
      handleAdd() {
        _this.visible = true
        _this.isEdit = false
      },
            // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },
      checkedChange(val, record) {
        const params = { id: record.id, state: val ? 1 : 2 }
        api.frequencyConfigUpdate(params).then((res) => {
          if (res.code === '000000') {
            record.state = val
            this.getList()
          } else {
            record.state = !val
          }
        })
        .catch(() => {
          record.state = !val
        })
      },
      async getList() {
        _this.loading = true
        const [start_date, end_date] = state.times
        _this.searchForm.start_date = start_date
        _this.searchForm.end_date = end_date
        const res = await api.ipAddressWhiteList({
          ...state.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize,
        })
        const frequencyList = res?.data?.list || []
        const pagination = res?.data?.pagination || _this.pagination
        _this.data = frequencyList
        _this.pagination.total = pagination.total
        _this.loading = false
      },
      getOrg(record, type) {
        const obj = _this.platformList.find(
          (item) =>
            Number(item.project) === Number(record.project) &&
            Number(item.staff_style) === Number(record.staff_style) &&
            Number(item.type) === Number(record.type)
        )
        return obj ? obj[type] : ''
      },
      getOrgList(record) {
       if (record.businessLines.length === 0) {
        return '全部'
       } else {
        return record.businessLines.map(item => this.getOrg(item, 'org')).join('<br/>')
       }
      },
      async getPlatform() {
        const res = await api.LineList()
        state.platformList = res.data
      },
      changeIsShow(params) {
        api.updateInterviewIsShow(params).then((res) => {
          this.getList()
        })
      },
      format(value) {
        return value === 1
      },
      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        this.search()
      },
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...compuedFun(),
      ...methods,
    }
  },
}
</script>
./business/whiteListSet
